import { imgUrl } from '@bww/beke-lib/sanity-client'
import Image from 'next/image'
import styles from './Details.module.scss'
import classNames from 'classnames'

const MAX_IMAGE_DISPLAY_WIDTH = 820

export default function Details({
  designOverview,
  highlights,
  images,
  imageCredits,
}) {
  return (
    <section className={styles.detailsWrapper}>
      <div className={styles.blueBar} />

      <div className={styles.designOverview}>
        <div className={styles.contentContainer}>
          {designOverview && (
            <>
              <h2 className={classNames(styles.sectionHeading, 'h4')}>
                Design overview
              </h2>
              <p style={{ whiteSpace: 'pre-wrap' }}>{designOverview}</p>
            </>
          )}
        </div>
      </div>

      <div className={styles.highlights}>
        <div className={styles.contentContainer}>
          {highlights && (
            <h2 className={classNames(styles.sectionHeading, 'h4')}>
              Project highlights
            </h2>
          )}
          <div className={styles.highlightItems}>
            {Array.isArray(highlights) &&
              highlights.map((highlight) => (
                <div className={styles.highlightItem} key={highlight._key}>
                  <h3 className={classNames(styles.highlightItem__title, 'h5')}>
                    {highlight.title}
                  </h3>
                  <p style={{ whiteSpace: 'pre-wrap' }}>{highlight.text}</p>
                </div>
              ))}
          </div>
        </div>
      </div>

      <div className={styles.imagesWrapper}>
        {imageCredits && (
          <div className={styles.imageCredit}>
            <small>Images courtesy of {imageCredits.join(', ')}</small>
          </div>
        )}
        {images.map((image, i) => {
          const displayWidth = MAX_IMAGE_DISPLAY_WIDTH
          const displayHeight = displayWidth / image.aspectRatio
          return (
            <div className={styles.imgWrapper} key={image._key}>
              <Image
                src={imgUrl(image)
                  .width(displayWidth * 2)
                  .url()}
                alt={image.alt || ''}
                style={{ objectFit: 'cover' }}
                placeholder={image?.lqip ? 'blur' : undefined}
                blurDataURL={image?.lqip}
                width={displayWidth}
                height={displayHeight}
              />
            </div>
          )
        })}
      </div>
    </section>
  )
}
